// UPDATE TEXT
// @param domNode {htmlNode} dom element containing text to be replaced
// @param text {string} text string to replace current text with
export default function(domNode, text) {
  // bail out if no node or text
  if (!domNode || typeof text === 'undefined' || text === null) {
    return;
  }

  // turn text to string and trim trailing/leading spaces
  let textAsString = String(text);
  textAsString = textAsString.trim();

  // check new text against current text
  const currentText = domNode.textContent;
  if (currentText !== textAsString) {
    // change if different
    domNode.textContent = textAsString;

    // add update attribute
    domNode.setAttribute('data-updated', 'true');
  } else {
    // remove update attribute if same
    domNode.removeAttribute('data-updated');
  }
}
